// extracted by mini-css-extract-plugin
export default {"additional-note":"AdditionalNoteInput_additional-note__d249q","buttons":"AdditionalNoteInput_buttons__fHL5-","section":"AdditionalNoteInput_section__thI+L"};